export default "__VITE_ASSET__CeBSMepL__"